import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const checkVideoURL = createAsyncThunk('checkVideoURL/checkVideoURL', async (data) => {
    try {
        const res = await axios({
            method: 'post',
            url: process.env.REACT_APP_API_URL + `check_url_status`,
            data: {
                long_url: data.video_url
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

